import { createAlgoliaClients } from "@raumagarn/algolia";
// import { type BrowseSearchRequest, isEmptyQueryRequest } from "@raumagarn/cache";
import { env } from "~/env";

const {
	client: algoliaClient,
	searchClient: rawSearchClient,
	analyticsClient,
} = createAlgoliaClients({
	appId: env.NEXT_PUBLIC_ALGOLIA_APP_ID,
	apiKey: env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
	analyticsKey: env.NEXT_PUBLIC_ALGOLIA_ANALYTICS_API_KEY,
});

export { algoliaClient, analyticsClient };

// Browse cache disabled: rule/merchandising changes made directly in the Algolia
// dashboard have no webhook to invalidate on, so cached empty-query results could
// go stale until a product write happens to bump the version. Re-enable once the
// invalidation story (scheduled poll, etc.) is sorted.
export const searchClient = rawSearchClient;

// const fetchFromBrowseCache = async (requests: BrowseSearchRequest[]): Promise<unknown[]> => {
// 	const response = await fetch("/api/algolia/browse", {
// 		method: "POST",
// 		headers: { "Content-Type": "application/json" },
// 		body: JSON.stringify({ requests }),
// 	});

// 	if (!response.ok) {
// 		throw new Error(`Browse cache proxy responded with ${response.status}`);
// 	}

// 	const { results } = (await response.json()) as { results: unknown[] };
// 	return results;
// };

// export const searchClient: typeof rawSearchClient = {
// 	...rawSearchClient,
// 	search: (async (params: unknown, requestOptions?: unknown) => {
// 		const requests = (
// 			Array.isArray(params) ? params : (params as { requests: unknown[] }).requests
// 		) as BrowseSearchRequest[];

// 		const cacheableIndexes: number[] = [];
// 		const liveIndexes: number[] = [];
// 		requests.forEach((req, index) => {
// 			(isEmptyQueryRequest(req) ? cacheableIndexes : liveIndexes).push(index);
// 		});

// 		const cacheableRequests = cacheableIndexes.map((index) => requests[index]);
// 		const liveRequests = liveIndexes.map((index) => requests[index]);

// 		const [cachedResults, liveResults] = await Promise.all([
// 			cacheableRequests.length
// 				? fetchFromBrowseCache(cacheableRequests).catch(() =>
// 						// Redis/proxy outage degrades to "no caching," never to "search is broken".
// 						rawSearchClient
// 							.search(cacheableRequests as never, requestOptions as never)
// 							.then((result) => result.results),
// 					)
// 				: Promise.resolve([]),
// 			liveRequests.length
// 				? rawSearchClient
// 						.search(liveRequests as never, requestOptions as never)
// 						.then((result) => result.results)
// 				: Promise.resolve([]),
// 		]);

// 		const results: unknown[] = new Array(requests.length);
// 		cacheableIndexes.forEach((originalIndex, i) => {
// 			results[originalIndex] = cachedResults[i];
// 		});
// 		liveIndexes.forEach((originalIndex, i) => {
// 			results[originalIndex] = liveResults[i];
// 		});

// 		return { results };
// 	}) as typeof rawSearchClient.search,
// };
